import type { SVGComponentProps } from 'BreetHelpers';

export const PinIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='123'
		height='123'
		viewBox='0 0 123 123'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<g clipPath='url(#clip0_11029_168345)'>
			<path
				d='M103.438 116.238H19.5625C9.05144 116.238 0.5 107.687 0.5 97.1758C0.5 86.6647 9.05144 78.1133 19.5625 78.1133H103.438C113.949 78.1133 122.5 86.6647 122.5 97.1758C122.5 107.687 113.949 116.238 103.438 116.238Z'
				fill='#F7F2F4'
			/>
			<path
				d='M49.5859 103.121C52.8759 103.121 55.543 100.454 55.543 97.1641C55.543 93.8741 52.8759 91.207 49.5859 91.207C46.296 91.207 43.6289 93.8741 43.6289 97.1641C43.6289 100.454 46.296 103.121 49.5859 103.121Z'
				fill='#6D737F'
			/>
			<path
				d='M25.7578 103.121C29.0478 103.121 31.7148 100.454 31.7148 97.1641C31.7148 93.8741 29.0478 91.207 25.7578 91.207C22.4678 91.207 19.8008 93.8741 19.8008 97.1641C19.8008 100.454 22.4678 103.121 25.7578 103.121Z'
				fill='#6D737F'
			/>
			<path
				d='M75.7969 37.5977H47.2031C45.2292 37.5977 43.6289 35.9974 43.6289 34.0234V24.0156C43.6289 14.1615 51.6459 6.14453 61.5 6.14453C71.3541 6.14453 79.3711 14.1615 79.3711 24.0156V34.0234C79.3711 35.9974 77.7708 37.5977 75.7969 37.5977ZM50.7773 30.4492H72.2227V24.0156C72.2227 18.1032 67.4125 13.293 61.5 13.293C55.5875 13.293 50.7773 18.1032 50.7773 24.0156V30.4492Z'
				fill='#6D737F'
			/>
			<path
				d='M61.5 6.14453V13.293C67.4125 13.293 72.2227 18.1032 72.2227 24.0156V30.4492H61.5V37.5977H75.7969C77.7708 37.5977 79.3711 35.9974 79.3711 34.0234V24.0156C79.3711 14.1615 71.3541 6.14453 61.5 6.14453Z'
				fill='#5E5F69'
			/>
			<path
				d='M84.1367 65.9609H38.8633C36.8894 65.9609 35.2891 64.3606 35.2891 62.3867V34.0312C35.2891 32.0573 36.8894 30.457 38.8633 30.457H84.1367C86.1106 30.457 87.7109 32.0573 87.7109 34.0312V62.3867C87.7109 64.3606 86.1106 65.9609 84.1367 65.9609Z'
				fill='#FFAC2B'
			/>
			<path
				d='M84.1367 30.457H61.5V65.9609H84.1367C86.1106 65.9609 87.7109 64.3606 87.7109 62.3867V34.0312C87.7109 32.0573 86.1106 30.457 84.1367 30.457Z'
				fill='#FF981E'
			/>
			<path
				d='M67.457 45.9453C67.457 43.9714 65.8567 42.3711 63.8828 42.3711H59.1172C57.1433 42.3711 55.543 43.9714 55.543 45.9453C55.543 47.5008 56.5385 48.8207 57.9258 49.3118V50.7109C57.9258 52.6849 59.5261 54.2852 61.5 54.2852C63.4739 54.2852 65.0742 52.6849 65.0742 50.7109V49.3118C66.4615 48.8207 67.457 47.5008 67.457 45.9453Z'
				fill='#FF981E'
			/>
			<path
				d='M103.438 78.1133H61.5V116.238H103.438C113.949 116.238 122.5 107.687 122.5 97.1758C122.5 86.6647 113.949 78.1133 103.438 78.1133Z'
				fill='#DFDAE0'
			/>
			<path
				d='M73.4141 103.129C76.704 103.129 79.3711 100.462 79.3711 97.1719C79.3711 93.8819 76.704 91.2148 73.4141 91.2148C70.1241 91.2148 67.457 93.8819 67.457 97.1719C67.457 100.462 70.1241 103.129 73.4141 103.129Z'
				fill='#5E5F69'
			/>
			<path
				d='M97.2422 103.129C100.532 103.129 103.199 100.462 103.199 97.1719C103.199 93.8819 100.532 91.2148 97.2422 91.2148C93.9522 91.2148 91.2852 93.8819 91.2852 97.1719C91.2852 100.462 93.9522 103.129 97.2422 103.129Z'
				fill='#5E5F69'
			/>
			<path
				d='M63.8828 42.3633H61.5V54.2773C63.4739 54.2773 65.0742 52.677 65.0742 50.7031V49.3039C66.4615 48.8128 67.457 47.493 67.457 45.9375C67.457 43.9636 65.8567 42.3633 63.8828 42.3633Z'
				fill='#FF8512'
			/>
		</g>
		<defs>
			<clipPath id='clip0_11029_168345'>
				<rect
					width='122'
					height='122'
					fill='white'
					transform='translate(0.5 0.191406)'
				/>
			</clipPath>
		</defs>
	</svg>
);
